import theband from "../../assets/img/theband.png";
import food from "../../assets/img/food.png";
import nike from "../../assets/img/nike.png";
import helendo from "../../assets/img/helendo.png";
import reactMovie from "../../assets/img/react_movie.png";

const data = [
  {
    id: "01",
    projectName: "Grab food",
    imgPath: food,
    prjDesc:
      "A simple demo landing page website, i did this project to study TailwindCSS and responsive layout.",
    githubLink: "https://github.com/huynth1801/landing-page-tailwind",
    liveDemo: "https://comforting-daifuku-846607.netlify.app/",
  },
  {
    id: "02",
    projectName: "Nike website",
    imgPath: nike,
    prjDesc: "Nike clone website, not responsive yet.",
    githubLink: "https://github.com/huynth1801/NikeWebsite",
    liveDemo: "https://huynth1801.github.io/NikeWebsite/",
  },
  {
    id: "03",
    projectName: "React Movie App",
    imgPath: reactMovie,
    prjDesc:
      "React Movie App with Dark Mode using ReactJS, TailwindCSS, SCSS and using Axios to fetch data from TMDB API",
    githubLink:
      "https://github.com/huynth1801/react-tailwind-movieapp/tree/master",
    liveDemo: "https://sunfix.netlify.app/",
  },
  {
    id: "04",
    projectName: "E-commerce website",
    imgPath: helendo,
    prjDesc:
      "An online shop, i created to learn more about ReactJS, Redux, TailwindCSS",
    githubLink: "https://github.com/huynth1801/Shop-clone-react",
    liveDemo: "https://helendoshop.netlify.app/home",
  },
];

export default data;
